<mat-toolbar color="primary" class="mat-elevation-z5">
  <div class="equipartition">
    <button attr.aria-label="{{ 'Toolbar.menu' | translateAsync:lang | async }}" mat-icon-button
      matTooltip="{{ 'Toolbar.menu' | translateAsync:lang | async }}" (click)="toggleSidenav($event)">
      <mat-icon>menu</mat-icon>
    </button>
    <button attr.aria-label="{{ 'Toolbar.return_to_homepage' | translateAsync:lang | async }}" class="menu-logo-button" routerLink="/" mat-button>
      <img src="assets/images/gapmaps-logo.svg" alt="Logo" class="logo menu-logo-button" style="height: 35px; padding-right: 6px;" />
      <span class="toolbar-title" l10nTranslate>title</span>
    </button>
  </div>


  <!-- This fills the remaining space of the current row -->
  <div class="search-slot">
    <ng-container [cdkPortalOutlet]="appBarPortals.searchPortal$ | async">
    </ng-container>
  </div>
  <div class="equipartition">
    <div class="context-actions">
      <ng-container [cdkPortalOutlet]="appBarPortals.contextActionsPortal$ | async">
          <ng-content></ng-content>
      </ng-container>
    </div>
    <!-- <mat-divider [vertical]="true" style="background:white"></mat-divider> -->
    <button class="toolbar-spacer" attr.aria-label="{{ 'Toolbar.change_language' | translateAsync:lang | async }}"
      mat-icon-button matTooltip="{{ 'Toolbar.change_language' | translateAsync:lang | async }}"
      (click)="openLanguageDialog()">
      <mat-icon>translate</mat-icon>
    </button>
    <button class="toolbar-spacer" attr.aria-label="{{ 'Toolbar.about' | translateAsync:lang | async }}" mat-icon-button
      matTooltip="{{ 'Toolbar.about' | translateAsync:lang | async }}" (click)="openAboutDialog()">
      <mat-icon>info</mat-icon>
    </button>
    <mat-menu #profileMenu="matMenu">
      <!-- <button mat-menu-item>Settings</button> -->
      <!-- <button mat-menu-item>Help</button> -->
      <button mat-menu-item (click)="logOut()" attr.aria-label="{{ 'Verbs.log_out' | translateAsync:lang | async }}" l10nTranslate>Verbs.log_out</button>
    </mat-menu>

    <button class="toolbar-spacer" mat-mini-fab [matMenuTriggerFor]="profileMenu" style="background-color: #60b5c5">
      <mat-icon>person</mat-icon>
    </button>
  </div>

</mat-toolbar>
